import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { icons } from 'smartsuite-ui';
import MenuItem from '@material-ui/core/MenuItem';
import DashboardContext from '../../../shared/hooks/dashboardContext';
import {
    getFilterSelectOption,
    getFilterValueOption,
} from '../widgetMenuUtils';
import { useLabelContext } from '../../../shared/hooks/labelContext';

export default function WidgetContextMenuActionFilter(props) {
    const { dashboardLabels, predicateLabels } = useLabelContext();
    const { selectOptions } = useContext(DashboardContext);

    function onClick() {
        const option = getFilterSelectOption(
            props.action.filterKey,
            props.availableFilters,
            props.dataItem.name,
            selectOptions
        );
        props.handleWidgetMenuFilter(
            getFilterValueOption(
                props.action.dashboardFilterKey,
                option,
                predicateLabels.isIn
            )
        );
        props.onClose();
    }

    return (
        <MenuItem key={props.action.key} onClick={onClick}>
            <span className={`${icons.filter} widget-context-menu__icon`} />
            <span>{`${dashboardLabels.filterOn} ${props.filterName}`}</span>
        </MenuItem>
    );
}

WidgetContextMenuActionFilter.propTypes = {
    action: PropTypes.instanceOf(Object).isRequired,
    availableFilters: PropTypes.instanceOf(Object),
    dataItem: PropTypes.instanceOf(Object).isRequired,
    filterName: PropTypes.string.isRequired,
    handleWidgetMenuFilter: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
